import React from "react";
import useStats from "../hooks/useStats";
import "./css/QuickStats.css";

export default function QuickStats() {
    const { stats, loading } = useStats();

    // show a consistent placeholder while individual counts load
    const show = (key) => (loading?.[key] ? "…" : (stats?.[key] ?? 0));

    return (
        <div className="card small quick-stats-card">
            <h4 style={{ marginTop: 0 }}>Quick stats</h4>
            <div className="stats-grid" style={{ marginTop: 8 }}>
                <div>
                    <div className="stat-num">{show("users")}</div>
                    <div className="stat-label">Total users</div>
                </div>
                <div>
                    <div className="stat-num">{show("publicTrips")}</div>
                    <div className="stat-label">Trips created</div>
                </div>
                <div>
                    <div className="stat-num">{show("aiTrips")}</div>
                    <div className="stat-label">AI trips</div>
                </div>
            </div>
        </div>
    );
}
